import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cardex-form',
  templateUrl: './cardex-form.component.html',
  styleUrls: ['./cardex-form.component.scss']
})
export class CardexFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
